import { Loader } from '@googlemaps/js-api-loader';
import { useEffect, useState } from 'react'
import { MAP_RENDER_API_KEY } from '../utils/shared/constants';
import { DealFilters, useDeals } from '../hooks/useDeals';
import { generateMapPin } from '../utils/presentation';
import DealModal from '../components/modals/DealModal';
import { Deal } from '../models/shared/Deal';
import { useOrganization } from '../context/OrganizationContext';
import { AdvancedButton } from '../components/AdvancedButton';
import { OverlayTrigger } from 'react-bootstrap';
import DealFiltersPicker from '../components/DealFiltersPicker';

interface Props { }

function MapPage(props: Props) {
    const [filters, setFilters] = useState<DealFilters>({});
    const { allDeals } = useDeals({ filters });
    const { organization } = useOrganization();
    const [openDeal, setOpenDeal] = useState<Deal | null>(null);
    const [map, setMap] = useState<google.maps.Map | null>(null);

    useEffect(() => {
        const createMap = async () => {
            const loader = new Loader({ apiKey: MAP_RENDER_API_KEY });

            const mapElement = document.getElementById("map");

            if (!mapElement) {
                return;
            }
            try {
                const { Map } = await loader.importLibrary('maps');
                const newMap = new Map(mapElement,
                    {
                        zoom: 13,
                        mapId: 'main_map',
                        clickableIcons: false,
                        fullscreenControl: false,
                    });
                setMap(newMap);

            } catch (error) {
                console.error('Error loading map', error);
            }

        }

        createMap();
    }, [])

    useEffect(() => {
        if (!map) {
            return;
        }
        const updatePins = async () => {
            const loader = new Loader({ apiKey: MAP_RENDER_API_KEY });

            const markers: google.maps.marker.AdvancedMarkerElement[] = [];
            try {
                const { LatLngBounds } = await loader.importLibrary('core');
                const { PinElement, AdvancedMarkerElement } = await loader.importLibrary('marker');

                const bounds = new LatLngBounds();

                for (const deal of allDeals) {
                    if (!deal.place?.geocoding) {
                        continue;
                    }
                    const organizationSteps = organization.dealSteps || [];
                    const dealStep = organizationSteps.find(s => s.id === deal.stepId);
                    const faPin = generateMapPin(PinElement, { backgroundColor: dealStep?.color });
                    const marker = new AdvancedMarkerElement({
                        position: deal.place.geocoding,
                        map,
                        content: faPin.element,
                    });
                    marker.addListener('gmp-click', () => setOpenDeal(deal));
                    markers.push(marker);
                    bounds.extend(deal.place.geocoding);
                }

                if (organization.place?.geocoding) {
                    const orgPin = generateMapPin(PinElement, { type: 'home' });
                    const orgMarker = new AdvancedMarkerElement({
                        position: organization.place.geocoding,
                        map,
                        content: orgPin.element,
                    });
                    markers.push(orgMarker);
                    bounds.extend(organization.place.geocoding);
                }

                map.fitBounds(bounds);
            } catch (error) {
                console.error('Error loading map', error);
            }

            return markers;
        }

        const markersPromise = updatePins();
        return () => {
            markersPromise.then(markers => {
                for (const marker of markers) {
                    marker.remove();;
                }
            });
        }
    }, [allDeals, organization.dealSteps, organization.place, map])


    const hasFilter = filters?.steps?.length || filters?.tags?.length;

    return <div className='h-100 position-relative'>
        <OverlayTrigger
            placement='bottom-end'
            trigger={['click']}
            rootClose
            overlay={
                <div>
                    <DealFiltersPicker filters={filters} onUpdateFilters={setFilters} />
                </div>
            }
        >

            <AdvancedButton className='position-absolute map-overlay'
                variant={hasFilter ? 'primary' : 'map'} icon='bi-filter' style={{ margin: 10, right: 0 }} />
        </OverlayTrigger>
        <div id="map" className='h-100'>
        </div>
        {openDeal && <DealModal deal={openDeal} onClose={() => setOpenDeal(null)} />}
    </div>
}

export default MapPage
